export default __webpack_public_path__ + "static/media/savedIcon.1f0c16c1.svg";